/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'File-upload': {
    width: 22,
    height: 26,
    viewBox: '0 0 22 26',
    data: '<path pid="0" d="M21.5 9.5h-6v-9h-9v9h-6L11 20 21.5 9.5zM.5 23v3h21v-3H.5z" _fill="#00204D"/>'
  }
})
